import { Component, OnInit } from '@angular/core';
import { AuditoriaDto } from '../../../dto/auditoria/auditoria.dto';
import { AuditoriaService } from '../../../services/auditoria.service';

@Component({
  selector: 'app-ultimos-cambios',
  templateUrl: './ultimos-cambios.component.html',
  styleUrl: './ultimos-cambios.component.scss',
})
export class UltimosCambiosComponent implements OnInit {
  cambios: AuditoriaDto[] = [];
  usuarioId!: number;

  constructor(private auditoriaService: AuditoriaService) {}

  ngOnInit() {
    this.setUsuarioIdFromSession();
    this.obtenerCambiosRecientes();
  }

  setUsuarioIdFromSession() {
    const userInfo = sessionStorage.getItem('user_information_session');
    if (userInfo) {
      const parsedInfo = JSON.parse(userInfo);
      this.usuarioId = parsedInfo?.idUsuario;
    } else {
      console.error(
        'No se encontró user_information_session en sessionStorage.'
      );
    }
  }

  obtenerCambiosRecientes() {
    this.auditoriaService
      .obtenerCambiosRecientesPorUsuario(this.usuarioId)
      .subscribe({
        next: data => (this.cambios = data),
        error: err => console.error('Error al obtener cambios recientes:', err),
      });
  }

  formatTransaccion(transaccion: string, valorModificado: string): string {
    let transaccionformat = transaccion.replace(/_/g, ' ');

    const jsonObject = JSON.parse(valorModificado);
    let username;

    if (
      jsonObject.Username &&
      (transaccionformat == 'Creacion usuario' ||
        transaccionformat == 'Modificacion usuario')
    ) {
      username = jsonObject.Username;
      return transaccionformat.concat(' ').concat(username);
    }

    return transaccionformat;
  }

  getIconClass(transaccion: string): string {
    switch (transaccion.toLowerCase()) {
      case 'creacion_usuario':
        return 'fa fa-user';
      case 'modificacion_usuario':
        return 'fa fa-user';
      case 'modificacion_correos':
        return 'fa fa-envelope';
      case 'cambio correo':
        return 'fa fa-envelope';
      case 'modificacion alerta':
        return 'fa fa-bell';
      case 'modificacion_alertas':
        return 'fa fa-bell';
      default:
        return 'fa fa-info-circle text-primary';
    }
  }
}
